import { Injectable } from "@angular/core";
import { HttpWrapperService } from "../http-wrapper.service";
import { IPlaqueItem } from "../../interfaces/plaqueItem.interface";
import { map, Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { IHttpRequestOptions } from "../../interfaces/http-request-option.interface";
import { ICustomizeFormFields, ICustomizeFormResponse } from "../../interfaces/customizeform.interface";

@Injectable({
  providedIn: 'root'
})

export class CustomizePlaquesService {
   constructor(private httpWrapperService: HttpWrapperService) {}

  OrderAndPrintPlaque(plaqueId: number, customizeDetails: ICustomizeFormFields, isSaved: boolean,
    isSubmitForReview = false
  ): Observable<boolean> {
    const url = `CustomizePlaque/${plaqueId}`;
    const params: { [key: string]: string } = {};
    params['isSavePlaque'] = isSaved.toString();
    params['isSubmitForReview'] = isSubmitForReview.toString();
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const plaqueDetails = {
        dedicationTo : customizeDetails.firstLine,
        dedicationFrom : customizeDetails.lastLine,
        dedicationMessage : customizeDetails.description,
    }
    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: plaqueDetails,
        params: params
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: boolean) => response)
    );
  }

  GetPlaqueItemDetails(plaqueId: number): Observable<IPlaqueItem> {
    const url = `Plaque/item/${plaqueId}`;
    
    const options: IHttpRequestOptions = {
      url: url,
    };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: IPlaqueItem) => response)
    );    
  } 
  GetCustomizePlaqueDetails(plaqueId: number): Observable<ICustomizeFormFields> {
    const url = `CustomizePlaque/${plaqueId}`;
    
    const options: IHttpRequestOptions = {
      url: url,
    };
  
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
      map((response: ICustomizeFormResponse) => {
        return {
            firstLine: response.dedicationTo,  
            description: response.dedicationMessage,
            lastLine: response.dedicationFrom
        };
    })
    );
    
    
  } 
}